/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Albanian` - ALBANIAN
 * * `Amharic` - AMHARIC
 * * `Arabic` - ARABIC
 * * `Armenian` - ARMENIAN
 * * `Awadhi` - AWADHI
 * * `Azerbaijani` - AZERBAIJANI
 * * `Bashkir` - BASHKIR
 * * `Basque` - BASQUE
 * * `Belarusian` - BELARUSIAN
 * * `Bengali` - BENGALI
 * * `Bhojpuri` - BHOJPURI
 * * `Bosnian` - BOSNIAN
 * * `Brazilian Portuguese` - BRAZILIAN_PORTUGUESE
 * * `Bulgarian` - BULGARIAN
 * * `Burmese` - BURMESE
 * * `Cantonese (Yue)` - CANTONESE_YUE
 * * `Catalan` - CATALAN
 * * `Chhattisgarhi` - CHHATTISGARHI
 * * `Croatian` - CROATIAN
 * * `Czech` - CZECH
 * * `Danish` - DANISH
 * * `Dogri` - DOGRI
 * * `Dutch` - DUTCH
 * * `English` - ENGLISH
 * * `Estonian` - ESTONIAN
 * * `Faroese` - FAROESE
 * * `Finnish` - FINNISH
 * * `French` - FRENCH
 * * `Galician` - GALICIAN
 * * `Georgian` - GEORGIAN
 * * `German` - GERMAN
 * * `Greek` - GREEK
 * * `Gujarati` - GUJARATI
 * * `Haryanvi` - HARYANVI
 * * `Hebrew` - HEBREW
 * * `Hindi` - HINDI
 * * `Hungarian` - HUNGARIAN
 * * `Icelandic` - ICELANDIC
 * * `Indonesian` - INDONESIAN
 * * `Irish` - IRISH
 * * `Italian` - ITALIAN
 * * `Japanese` - JAPANESE
 * * `Javanese` - JAVANESE
 * * `Kannada` - KANNADA
 * * `Kashmiri` - KASHMIRI
 * * `Kazakh` - KAZAKH
 * * `Konkani` - KONKANI
 * * `Korean` - KOREAN
 * * `Kyrgyz` - KYRGYZ
 * * `Latvian` - LATVIAN
 * * `Lithuanian` - LITHUANIAN
 * * `Macedonian` - MACEDONIAN
 * * `Maithili` - MAITHILI
 * * `Malay` - MALAY
 * * `Malayalam` - MALAYALAM
 * * `Maltese` - MALTESE
 * * `Mandarin Chinese` - MANDARIN_CHINESE
 * * `Marathi` - MARATHI
 * * `Marwari` - MARWARI
 * * `Min Nan` - MIN_NAN
 * * `Moldovan` - MOLDOVAN
 * * `Mongolian` - MONGOLIAN
 * * `Montenegrin` - MONTENEGRIN
 * * `Nepali` - NEPALI
 * * `Norwegian` - NORWEGIAN
 * * `Oriya` - ORIYA
 * * `Pashto` - PASHTO
 * * `Persian (Farsi)` - PERSIAN_FARSI
 * * `Polish` - POLISH
 * * `Portuguese` - PORTUGUESE
 * * `Punjabi` - PUNJABI
 * * `Rajasthani` - RAJASTHANI
 * * `Romanian` - ROMANIAN
 * * `Russian` - RUSSIAN
 * * `Sanskrit` - SANSKRIT
 * * `Santali` - SANTALI
 * * `Serbian` - SERBIAN
 * * `Sindhi` - SINDHI
 * * `Sinhala` - SINHALA
 * * `Slovak` - SLOVAK
 * * `Slovenian` - SLOVENIAN
 * * `Somali` - SOMALI
 * * `Spanish` - SPANISH
 * * `Swahili` - SWAHILI
 * * `Swedish` - SWEDISH
 * * `Tagalog` - TAGALOG
 * * `Tajik` - TAJIK
 * * `Tamil` - TAMIL
 * * `Tatar` - TATAR
 * * `Telugu` - TELUGU
 * * `Thai` - THAI
 * * `Turkish` - TURKISH
 * * `Turkmen` - TURKMEN
 * * `Ukrainian` - UKRAINIAN
 * * `Urdu` - URDU
 * * `Uzbek` - UZBEK
 * * `Vietnamese` - VIETNAMESE
 * * `Welsh` - WELSH
 * * `Wu` - WU
 */
export enum Language {
  ALBANIAN = 'Albanian',
  AMHARIC = 'Amharic',
  ARABIC = 'Arabic',
  ARMENIAN = 'Armenian',
  AWADHI = 'Awadhi',
  AZERBAIJANI = 'Azerbaijani',
  BASHKIR = 'Bashkir',
  BASQUE = 'Basque',
  BELARUSIAN = 'Belarusian',
  BENGALI = 'Bengali',
  BHOJPURI = 'Bhojpuri',
  BOSNIAN = 'Bosnian',
  BRAZILIAN_PORTUGUESE = 'Brazilian Portuguese',
  BULGARIAN = 'Bulgarian',
  BURMESE = 'Burmese',
  CANTONESE_YUE = 'Cantonese (Yue)',
  CATALAN = 'Catalan',
  CHHATTISGARHI = 'Chhattisgarhi',
  CROATIAN = 'Croatian',
  CZECH = 'Czech',
  DANISH = 'Danish',
  DOGRI = 'Dogri',
  DUTCH = 'Dutch',
  ENGLISH = 'English',
  ESTONIAN = 'Estonian',
  FAROESE = 'Faroese',
  FINNISH = 'Finnish',
  FRENCH = 'French',
  GALICIAN = 'Galician',
  GEORGIAN = 'Georgian',
  GERMAN = 'German',
  GREEK = 'Greek',
  GUJARATI = 'Gujarati',
  HARYANVI = 'Haryanvi',
  HEBREW = 'Hebrew',
  HINDI = 'Hindi',
  HUNGARIAN = 'Hungarian',
  ICELANDIC = 'Icelandic',
  INDONESIAN = 'Indonesian',
  IRISH = 'Irish',
  ITALIAN = 'Italian',
  JAPANESE = 'Japanese',
  JAVANESE = 'Javanese',
  KANNADA = 'Kannada',
  KASHMIRI = 'Kashmiri',
  KAZAKH = 'Kazakh',
  KONKANI = 'Konkani',
  KOREAN = 'Korean',
  KYRGYZ = 'Kyrgyz',
  LATVIAN = 'Latvian',
  LITHUANIAN = 'Lithuanian',
  MACEDONIAN = 'Macedonian',
  MAITHILI = 'Maithili',
  MALAY = 'Malay',
  MALAYALAM = 'Malayalam',
  MALTESE = 'Maltese',
  MANDARIN_CHINESE = 'Mandarin Chinese',
  MARATHI = 'Marathi',
  MARWARI = 'Marwari',
  MIN_NAN = 'Min Nan',
  MOLDOVAN = 'Moldovan',
  MONGOLIAN = 'Mongolian',
  MONTENEGRIN = 'Montenegrin',
  NEPALI = 'Nepali',
  NORWEGIAN = 'Norwegian',
  ORIYA = 'Oriya',
  PASHTO = 'Pashto',
  PERSIAN_FARSI = 'Persian (Farsi)',
  POLISH = 'Polish',
  PORTUGUESE = 'Portuguese',
  PUNJABI = 'Punjabi',
  RAJASTHANI = 'Rajasthani',
  ROMANIAN = 'Romanian',
  RUSSIAN = 'Russian',
  SANSKRIT = 'Sanskrit',
  SANTALI = 'Santali',
  SERBIAN = 'Serbian',
  SINDHI = 'Sindhi',
  SINHALA = 'Sinhala',
  SLOVAK = 'Slovak',
  SLOVENIAN = 'Slovenian',
  SOMALI = 'Somali',
  SPANISH = 'Spanish',
  SWAHILI = 'Swahili',
  SWEDISH = 'Swedish',
  TAGALOG = 'Tagalog',
  TAJIK = 'Tajik',
  TAMIL = 'Tamil',
  TATAR = 'Tatar',
  TELUGU = 'Telugu',
  THAI = 'Thai',
  TURKISH = 'Turkish',
  TURKMEN = 'Turkmen',
  UKRAINIAN = 'Ukrainian',
  URDU = 'Urdu',
  UZBEK = 'Uzbek',
  VIETNAMESE = 'Vietnamese',
  WELSH = 'Welsh',
  WU = 'Wu',
}
